__turbopack_context__.v({
  "arrow": "CoreVideoGrid-module-scss-module__W7rDRG__arrow",
  "content": "CoreVideoGrid-module-scss-module__W7rDRG__content",
  "description": "CoreVideoGrid-module-scss-module__W7rDRG__description",
  "list": "CoreVideoGrid-module-scss-module__W7rDRG__list",
  "list-item": "CoreVideoGrid-module-scss-module__W7rDRG__list-item",
  "main": "CoreVideoGrid-module-scss-module__W7rDRG__main",
  "pdf": "CoreVideoGrid-module-scss-module__W7rDRG__pdf",
  "transcript": "CoreVideoGrid-module-scss-module__W7rDRG__transcript",
});
